import { MenuItem } from "@mui/joy";
import { formatDistanceToNow } from "date-fns";

import { TaskSet } from "@/core/types";

import { useModal } from "../modals/useModal";

type Props = {
  taskSet: TaskSet;
  onClose?: () => void;
  onEdit?: () => void;
  hideEdit?: boolean;
};

export default function TaskSetMenuItems({ taskSet, onClose, onEdit, hideEdit }: Props) {
  const { display: displayModal } = useModal();
  const onEditClick = () => {
    onClose && onClose();
    onEdit && onEdit();
  };

  const onCopyClick = () => {
    const url = new URL(
      `/gym/${taskSet.venue}/schedule/sets/${taskSet.uuid}`,
      window.location.origin,
    );
    navigator.clipboard.writeText(url.href);
    onClose && onClose();
  };

  const onAnnounceClick = () => {
    onClose && onClose();
    displayModal("ANNOUNCE_SET", { setUuid: taskSet.uuid });
  };

  return (
    <>
      {!hideEdit ? <MenuItem onClick={onEditClick}>Edit</MenuItem> : null}
      <MenuItem disabled>Print</MenuItem>
      <MenuItem disabled>Export</MenuItem>
      <MenuItem disabled={!!taskSet.announceTime} onClick={onAnnounceClick}>
        {taskSet.announceTime
          ? `Announced ${formatDistanceToNow(taskSet.announceTime)} ago`
          : "Announce"}
      </MenuItem>
      <MenuItem onClick={onCopyClick}>Copy link</MenuItem>
      <MenuItem onClick={() => displayModal("CONFIRM_DELETE_TASKSET", { taskSet })} color="danger">
        Delete
      </MenuItem>
    </>
  );
}
